import React from "react";
import { Box, Grid, ListItem, ListItemText, Typography } from "@mui/material";
import { FamilyMember } from "../../model/app_users_model";

export default function FamilyMembersTab({
  familyMembers,
}: {
  familyMembers: FamilyMember[];
}) {
  if (!familyMembers || familyMembers.length === 0) {
    return (
      <Grid item md={12} lg={12} sm={12} xs={12}>
        <Typography>{"-"}</Typography>
      </Grid>
    );
  }

  return (
    <Grid item md={12} lg={12} sm={12} xs={12}>
      <Grid container spacing={3}>
        {familyMembers.map((familyMember) => {
          return (
            <Grid item md={12} lg={12} sm={12} xs={12} key={familyMember?.id}>
              <ListItem
                sx={{
                  backgroundColor: "#F5E6F5",
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                }}
              >
                <ListItemText
                  primary={familyMember?.name || "-"}
                  secondary={familyMember?.gender || "-"}
                  primaryTypographyProps={{ fontWeight: "600" }}
                  secondaryTypographyProps={{ color: "#000000" }}
                />
              </ListItem>

              <Box sx={{ border: "1px solid #F5E6F5" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <ListItem>
                    <ListItemText
                      primary="Relationship"
                      secondary={familyMember?.relationship || "-"}
                      primaryTypographyProps={{ fontSize: 12 }}
                      secondaryTypographyProps={{
                        color: "#000000",
                        fontSize: 18,
                      }}
                    />
                  </ListItem>
                  <ListItem sx={{ textAlign: "right" }}>
                    <ListItemText
                      primary="Date of Birth"
                      secondary={familyMember?.dob?.toString() || "-"}
                      primaryTypographyProps={{ fontSize: 12 }}
                      secondaryTypographyProps={{
                        color: "#000000",
                        fontSize: 18,
                      }}
                    />
                  </ListItem>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <ListItem>
                    <ListItemText
                      primary="Occupation"
                      secondary={familyMember?.occupation || "-"}
                      primaryTypographyProps={{ fontSize: 12 }}
                      secondaryTypographyProps={{
                        color: "#000000",
                        fontSize: 18,
                      }}
                    />
                  </ListItem>
                  <ListItem sx={{ textAlign: "right" }}>
                    <ListItemText
                      primary="Mobile Number"
                      secondary={
                        familyMember?.mobileNumber
                          ? familyMember?.mobileNumber
                          : "NA"
                      }
                      primaryTypographyProps={{ fontSize: 12 }}
                      secondaryTypographyProps={{
                        color: "#000000",
                        fontSize: 18,
                      }}
                    />
                  </ListItem>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}


